import React from "react";
import { STYLE_TYPE } from "../../../config/constants";
import blockHTML from "../../../utils/blockHTML";

import styles from "./StoryBody.css";

export const styleToHTML = (style) => {
  if (style.toLowerCase() === STYLE_TYPE.BOLD) {
    return <span className={styles.bold} />;
  }
  if (style.toLowerCase() === STYLE_TYPE.ITALIC) {
    return <i />;
  }
  return <span />;
};

export const blockToHTML = (extras) => (block) => {
  const html = blockHTML[block.type.toLowerCase()];
  if (!html) {
    return blockHTML["default"];
  } else if (typeof(html) === "function") {
    return html(block, extras);
  } else {
    return html;
  }
};



// WEBPACK FOOTER //
// ./src/components/Library/StoryBody/conversionHelpers.js